<template>
  <div>
    <div class="content">
      <div class="searchContent">
        <div class="search_day">
          <div class="p_select search_day_list">
            <div class="search_label">查询日期</div>
            <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
              <el-date-picker v-model="beginDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                :picker-options="pickerDayOptions" prefix-icon="''" class="datepicker" @change="onSaCheckChanged" />
              <i class="el-icon-date" ref="iconDateStart"></i>
            </div>
          </div>
          <div class="p_select search_day_list">
            <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
              <el-date-picker v-model="endDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                :picker-options="pickerDayOptions" prefix-icon="''" class="datepicker" @change="onSaCheckChanged" />
              <i class="el-icon-date" ref="iconDateEnd"></i>
            </div>
          </div>
          <div class="p_select">
            <div class="search_label">检测部位</div>
            <el-select v-model="positionId" clearable filterable placeholder="请选择部位" @change="onSaCheckChanged">
              <el-option v-for="(item) in positionList" :key="item.index" :label="item.positionName"
                :value="item.positionId"></el-option>
            </el-select>
          </div>
          <div class="p_select">
            <el-select v-model="maintenanceType" clearable filterable placeholder="请选择工单类型" @change="onSaCheckChanged">
              <el-option
                      v-for="item in typeList"
                      :key="item.index"
                      :label="item.typeName"
                      :value="item.maintenanceType"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="list_box">
      <div class="sa_box">
        <div class="top">
          <div class="dot">
            <div class="spot"></div>
            <span>SA</span>
          </div>
          <a class="reset" @click="resetData">重置</a>
        </div>
        <div class="item">
          <el-radio-group v-model="saId">
            <el-radio v-for="(item) in orginUserArr" :key="item.index" @change="onSaCheckChanged" :label="item.saId">
              {{ item.saName }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="data_box">

        <div class="echarts">
          <div class="dot_box">
            <div class="dot"></div>
            <span>失销原因月对比</span>
          </div>

          <div id="test_distribution" class="deal_data"></div>

        </div>
        <div class="bottom_box">
          <div class="left">
            <div class="dot_box">
              <div class="dot"></div>
              <span>失销原因分布</span>
            </div>

            <div id="deal_nunber" class="deal_data"></div>
          </div>
          <div class="right">
            <div class="dot_box">
              <div class="dot"></div>
              <span>失销原因占比</span>
            </div>

            <div id="deal_project" class="deal_data"></div>
          </div>
        </div>
        <div class="table">
          <div class="left">
            <div class="dot_box">
              <div class="dot"></div>
              <span>失销原因统计</span>
            </div>
            <div class="table">
              <el-table id="querySADealFeedback"
                        ref="table2"
                        :data="countPositionReason"
                        :header-cell-style="getHeaderStyleNone"
                        :cell-style="setRowStyleColorNone"
                        show-summary
                        :summary-method="getSummaries"
                        style="overflow-x: auto">
                <el-table-column
                        v-for="(item, index) in countPositionReason[0]"
                        :key="item.id"
                        :prop="index"

                >
                  <template slot-scope="scope" v-if="index.indexOf('td') != -1">
                    <span>{{scope.row[index]}}</span>
                  </template>

                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import net from "../../assets/js/public";
import * as echarts from 'echarts';
export default {
  name: "PowerBI",
  data() {
    return {
      orgId: '',
      checkYear: '2022',
      beginDate: '',
      endDate: '',
      maintenanceType:'',
      typeList:[],

      allMonth: 12,
      checkMonth: '',

      pickerDayOptions: { // 按天 当天、当月可选
        disabledDate(time) {
          return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
        }
      },

      positionList: [],
      positionId: '',
      orginUserArr: [],
      saId: '',

      dataArr: [],
      labelText: [],
      monthList: [],
      adListArr:[],

      monthListArr: [],
      countPositionReason: [],//按项目统计

    }
  },
  created() {

    let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
    if (signInfo.orgId > 0) {
      this.orgId = signInfo.orgId
      this.orgName = signInfo.orgName
    }

    let obj = new Date();
    let month = obj.getMonth() + 1;
    let day = obj.getDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    this.beginDate = obj.getFullYear() + "-" + month + "-01";

    let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
    let afterMonth = after.getMonth() + 1;
    if (afterMonth < 10) afterMonth = "0" + afterMonth;
    let afterDay = after.getDate()
    if (afterDay < 10) afterDay = "0" + afterDay;
    this.endDate = after.getFullYear() + "-" + afterMonth + "-" + afterDay;


    this.checkMonth = month * 1

    this.getListData()
    this.getCountPositionReason()

    this.getPositionList()
    this.querySaList()
    this.orgDataMonth()
    this.queryOrgWorkType()



  },
  methods: {
    onMouseOver(item) {
      if (item == 'start') {
        this.$refs.iconDateStart.style.display = 'none';
      } else {
        this.$refs.iconDateEnd.style.display = 'none';
      }
    },
    onMouseleave(item) {
      if (item == 'start') {
        this.$refs.iconDateStart.style.display = 'block';
      } else {
        this.$refs.iconDateEnd.style.display = 'block';
      }
    },

    getHeaderStyleNone() {
      return "display:none";
    },
    setRowStyleColorNone(row, column, rowIndex, columnIndex) {
      if(row.rowIndex == 0 ){
        return 'background: #F5F7FA; color: #0D0E12'
      }else {
        return 'background: #fff; color: #0D0E12'
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property == "index") {
          sums[index] = '';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },

    onSaCheckChanged() {
      this.getListData()
      this.getCountPositionReason()
    },
    // 查询站点有数据的最近12个月
    orgDataMonth() {
      net.request("admin/manage/multi_report/orgDataMonth", "post", null).then(res => {
        if (res.code == 0) {
          this.monthListArr = res.data
        }
      })
    },
    // 获取所有部位
    getPositionList() {
      net.request("admin/manage/parts/getPositionList", "post").then(res => {
        if (res.code === 0) {
          this.positionList = res.data
        } else {
          net.message(this, "获取数据失败", "warning");
        }
      })
    },
    // 获取SA
    querySaList() {
      net.request("admin/manage/report/getSAByOrg", "post").then(res => {
        if (res.code === 0) {
          this.orginUserArr = res.data;
        } else {
          net.message(this, "获取数据失败", "warning");
        }
      });
    },
    queryOrgWorkType(){
      net.request("admin/manage/public/queryOrgWorkType", "get").then(res => {
        if (res.code === 0) {
          let data = res.data
          let workTypeList = []
          data.forEach((value,i)=>{
            for(var pl in value){
              workTypeList.push({
                'maintenanceType': pl,
                'typeName': value[pl]
              })
            }
          })
          this.typeList = workTypeList
        } else {
          net.message(this, res.msg, "warning");
        }
      });
    },
    resetData() {
      this.saId = ''
      this.getListData()
      this.getCountPositionReason()
    },
    getListData() {
      let _this = this
      const params = {
        beginDate: this.beginDate,
        endDate: this.endDate,
        orgId: this.orgId,
        saId: this.saId || null,
        positionId: this.positionId || null,
        maintenanceType: this.maintenanceType || null,
      }
      net.request("admin/manage/multi_report/lossOfSaleAnalysis", "post", null, params).then(res => {
        if (res.code == 0) {
          let data = res.data

          let monthList = []
          let percentage = []
          let resultArr = []

          let listArr = []
          let listIdArr = []

          for (let key in data) {
            for (let k in data[key]) {
              monthList.push(k)
              let list = data[key][k]
              percentage = [...percentage,...list]

              list.forEach(item => {
                item['month'] = k
              })
              // listArr.push(list)
              listArr = [...listArr,...list]
            }
          }
          percentage.forEach(el=>{
            const result = resultArr.findIndex(ol=>{return el.reason*1 === ol.reason*1})
            if(result!== -1){
              resultArr[result].num = percentage[result].num + el.num
            }else{
              resultArr.push(el)
            }
          })

          let dataArr = []
          let labelText = []

          resultArr.forEach(item => {
            dataArr.push({
              name: item.reasonLabel,
              value: item.num
            })
            labelText.push(item.reasonLabel)
            listIdArr.push(item.reason)
          })

          this.dataArr = dataArr
          this.labelText = labelText
          this.monthList = [...new Set(monthList)]

          let objArr = listArr.reduce((pre, cur) => {
            (pre[cur.reason] || (pre[cur.reason] = [])).push(cur);
            return pre
          }, [])

          for (let key in objArr){
            objArr[key].forEach(item => {
              for(let i = 0; i < monthList.length; i++){ // 不存在的月份补充数据
                if(monthList[i] !== item.month){
                  objArr[key].push({
                    month:monthList[i],
                    reason: item.reason,
                    reasonLabel: item.reasonLabel,
                    num: 0,
                  })
                }
              }
            })

            let obj = {};
            objArr[key] = objArr[key].reduce(function(item, next) { //去重
              obj[next.month] ? '' : obj[next.month] = true && item.push(next);
              return item
            }, []);
            objArr[key] = objArr[key].sort(_this.compareAes("month"));
          }

          let adListArr = []
          for (let key in objArr){
            let data = []
            for (let i = 0; i < objArr[key].length; i++){
              monthList.forEach(item => {
                if(item == objArr[key][i].month){
                  data.push(objArr[key][i].num)
                }
              })
            }
            adListArr.push({
              name: objArr[key][0].reasonLabel,
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series'
              },
              data: data
            })
          }
          this.adListArr = adListArr

          this.drawLine()
        }
      })
    },
    //根据部位统计原因数量
    getCountPositionReason() {
      const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
      if (this.orgId === "" || this.orgId === null || this.startTimeNoSoldSA === "" || this.startTimeNoSoldSA === null || this.endTimeNoSoldSA === "" || this.endTimeNoSoldSA === null) {
        this.$message({
          message: "请选择查询站点和日期区间",
          type: 'warning',
          duration: 2000,
          offset: windiwHight / 2
        });
        return;
      }
      if (this.startTimeNoSold * 1 !== 0 && this.endTimeNoSold * 1 !== 0) {
        if (this.startTimeNoSold >= this.endTimeNoSold) {
          this.$message({
            message: "结束日期不得小于或等于开始日期",
            type: 'warning',
            duration: 2000,
            offset: windiwHight / 2
          });
          return;
        }
      }
      const params = {
        orgId: this.orgId,
        saId: this.saId,
        start: new Date(this.beginDate).getTime(),
        end: new Date(this.endDate).getTime(),
      }
      net.request('admin/manage/report/countReason3', 'post', params).then(res => {
        if (res.retcode == 1) {
          this.$message({
            message: '查询成功',
            type: 'success',
            duration: 2000,
            offset: windiwHight / 2
          });
          let data = res.data
          if (data) {
            data[0][data[0].length - 1] = "合计"
          }
          let labelArr = []
          let dataList = []
          for (let i = 0; i < data[0].length; i++) {
            labelArr.push('td' + i)
          }
          for (let i = 0; i < data.length - 2; i++) {
            let list = {}
            for (let j = 0; j < data[i].length; j++) {
              let label = 'td' + j
              let dataStr = data[i][j]
              list[label] = dataStr
            }
            dataList.push(list)
          }
          this.countPositionReason = dataList
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
            duration: 2000,
            offset: windiwHight / 2
          });
        }
      })
    },

    drawLine() {
      let _this = this
      let labelText = _this.labelText
      let chart1 = document.getElementById('test_distribution');
      let myChart1 = echarts.init(chart1);
      let option1;
      myChart1.clear();
      if(labelText.length === 0){
        option1 = {
          xAxis: {
            type: 'category',
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [],
              type: 'bar'
            }
          ]
        };
      }else {
        option1 = {
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          legend: {
            data: labelText
          },
          xAxis: [
            {
              type: 'category',
              data: _this.monthList,
              axisPointer: {
                type: 'shadow'
              },
              axisLabel: {
                interval: 0,
                rotate: 20//角度顺时针计算的
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '台次',
              axisLabel: {
                formatter: '{value}'
              }
            }
          ],
          series: _this.adListArr
        }
      }

      option1 && myChart1.setOption(option1);


      const chart2 = document.getElementById('deal_nunber');
      const myChart2 = echarts.init(chart2);
      let option2;
      option2 = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '20%',
          containLabel: true
        },
        color: ['#4b7cf3', '#cb7bf4', '#ff458c', '#2acd72', '#f5cb29', '#f24354', '#29D3BF'],
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: labelText
        },
        series: [
          {
            // name: 'Direct',
            type: 'bar',
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            label: {
              normal: {
                show: true,
                position: "right",
              },
              formatter: '{b}: {d}%',
            },
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function (params) {
                  //通过判断选中的名字改变柱子的颜色样式
                  if (_this.checkName === params.name) {
                    return "#2b54fc"
                  } else {
                    return new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                      offset: 0,
                      color: "#2b54fc" // 0% 处的颜色
                    }, {
                      offset: 0.6,
                      color: "#5576fc" // 60% 处的颜色
                    }, {
                      offset: 1,
                      color: "#7d96f7" // 100% 处的颜色
                    }], false)
                  }
                }
              },
            },
            data: _this.dataArr
          },
        ]
      }
      option2 && myChart2.setOption(option2);



      const data3 = document.getElementById('deal_project');
      const myChart3 = echarts.init(data3);
      let option3;
      option3 = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: "item",
          formatter: '{d}%\n{b}',
        },
        color: ['#4b7cf3', '#cb7bf4', '#ff458c', '#2acd72', '#f5cb29', '#f24354', '#29D3BF'],
        series: [
          {
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "45%"],
            // avoidLabelOverlap: false,//是否启用防止标签重叠策略
            hoverAnimation: true,
            label: {
              formatter: '{b} \n {d}%',
            },
            itemStyle:{
              normal: {
                labelLine: {
                  length:2
                }
              }
            },
            data: _this.dataArr
          }
        ]
      }
      option3 && myChart3.setOption(option3);

      window.addEventListener("resize", () => {
        myChart1.resize()
        myChart2.resize()
        myChart3.resize()
      })
    },

    changeYear() {
      let checkYear = this.checkYear
      let obj = new Date();
      let year = obj.getFullYear()
      let month = obj.getMonth() + 1;

      if (checkYear < year) {
        this.allMonth = 12
      }
      if (checkYear == year) {
        this.checkMonth = month
      } else {
        this.checkMonth = ''
      }
    },
    selectMonth(item) {
      let year = item.substring(0, 4) * 1
      let month = item.substring(5, 8) * 1
      let endMonth = ''
      let startMonth = item + '-01'
      if (month === 12) {
        endMonth = year + 1 + "-" + "01-01"
      } else {
        let checkMonth = month + 1
        if (checkMonth < 10) checkMonth = "0" + checkMonth;
        endMonth = year + "-" + checkMonth + "-01"
      }
      this.beginDate = startMonth
      this.endDate = endMonth
      this.getListData()
      this.getCountPositionReason()
    },

    // 排序 降序
    compareDes: function (property) {
      return function (a, b) {
        const value1 = a[property];
        const value2 = b[property];
        return value2 - value1;
      }
    },
    compareAes: function (property) {
      return function (a, b) {
        const value1 = a[property].replace('-','');
        const value2 = b[property].replace('-','');
        return value1 - value2;
      }
    },
    //监听键盘Esc按键事件
    handleKeyup(event) {
      let self = this;
      const e = event || window.event || arguments.callee.caller.arguments[0]
      if (!e) return
      if (e.keyCode == 27) {
        let routeNmae = self.$route.name
        if (routeNmae != 'inCommonUse') {
          e.stopImmediatePropagation();
          self.$router.replace({ name: 'inCommonUse' })
        }
      }
    },



  },
  mounted() {
    window.addEventListener('keyup', this.handleKeyup)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup)
  }
};
</script>

<style lang="less" scoped>
  .content {
    display: flex;
    flex-direction: column;
    margin: 12px 0 0 12px;
    background: #fff;
    border-radius: 8px;

    .searchContent {
      /*.search_month {
        overflow: hidden;
        padding-bottom: 10px;
        padding-left: 12px;

        .month_list {
          display: flex;
          margin-top: 10px;
          float: left;

          .month_item {
            width: 60px;
            height: 30px;
            display: block;
            margin-right: 6px;
            line-height: 30px;
            background: #FFFFFF;
            box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
            border-radius: 4px;
            color: #364556;
            font-size: 14px;
          }

          .select_month {
            background: #2B54FC;
            border-radius: 4px;
            color: #FFFFFF;
          }
        }
      }*/

      .search_day {
        display: flex;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 12px;

        .p_select {
          display: flex;
          margin-right: 12px;
          font-size: 12px;
          float: left;

          .search_label {
            font-family: 'PingFang SC';
            font-style: normal;
            margin-right: 12px;
            font-weight: 500;
            font-size: 14px;
            line-height: 40px;
            color: #787E86;
            white-space: nowrap
          }

          .el-input,
          .el-select {
            width: 160px;
          }
        }
      }
    }
  }

  .list_box {
    overflow: hidden;

    .sa_box {
      float: left;
      width: 170px;
      height: calc(100vh - 238px);
      min-height: 512px;
      overflow-y: initial;
      overflow-x: hidden;
      margin-left: 12px;
      margin-top: 12px;
      background: #FFFFFF;
      border-radius: 8px;
      .top {
        overflow: hidden;
        .dot {
          float: left;
          display: inline-flex;
          .spot {
            width: 4px;
            height: 10px;
            margin-top: 12px;
            margin-left: 12px;
            background: #2B54FC;
            border-radius: 3px;
          }
          span {
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 36px;
            color: #0D0E12;
            margin-left: 8px;
          }
        }
        .reset {
          float: right;
          margin-top: 12px;
          margin-right: 12px;
          font-weight: 400;
          font-size: 12px;
          color: #2B54FC;
        }
      }
      .item {
        /deep/ .el-radio{
          width: 100%;
          text-align: left;
          margin-left: 12px;
          line-height: 30px;
          .el-radio__inner {
            border-radius:0 !important;
          }
          .el-radio__input.is-checked .el-radio__inner::after {
            background: #2B54FC;
            content: '';
            width: 9px;
            height: 5px;
            border: 2px solid white;
            border-top: transparent;
            border-right: transparent;
            text-align: center;
            display: block;
            position: absolute;
            top: 2px;
            left: 1px;
            vertical-align: middle;
            transform: rotate(-45deg);
            border-radius: 0px;
            background: none;

          }
        }
      }
    }

    .data_box {
      float: left;
      margin-left: 10px;
      height: 100%;
      margin-top: 12px;
      width: calc(100% - 196px);

      .echarts {
        width: 100%;
        height: calc((100vh - 250px) / 2);
        min-height: 250px;
        /*height: 300px;*/
        background: #fff;
        margin-bottom: 10px;
        border-radius: 8px;

        .dot_box {
          overflow: hidden;
          padding-top: 10px;
          margin-left: 12px;

          .dot {
            width: 4px;
            height: 10px;
            margin-top: 6px;
            background: #2B54FC;
            border-radius: 3px;
            float: left;
          }

          span {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #0D0E12;
            float: left;
            margin-left: 8px;
          }
        }

        .deal_data {
          width: 100%;
          height: 100%;
        }
      }

      .bottom_box {
        width: 100%;
        height: calc((100vh - 250px) / 2);
        min-height: 250px;
        margin-bottom: 10px;
        overflow: hidden;

        .left {
          width: 55%;
          height: 100%;
          background: #fff;
          float: left;
          border-radius: 8px;

          .dot_box {
            overflow: hidden;
            padding-top: 10px;
            margin-left: 12px;

            .dot {
              width: 4px;
              height: 10px;
              margin-top: 6px;
              background: #2B54FC;
              border-radius: 3px;
              float: left;
            }

            span {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              color: #0D0E12;
              float: left;
              margin-left: 8px;
            }
          }

          .deal_data {
            width: 100%;
            height: 100%;
          }
        }

        .right {
          width: calc(45% - 12px);
          height: 100%;
          background: #fff;
          float: right;
          border-radius: 8px;

          .dot_box {
            overflow: hidden;
            padding-top: 10px;
            margin-left: 12px;

            .dot {
              width: 4px;
              height: 10px;
              margin-top: 6px;
              background: #2B54FC;
              border-radius: 3px;
              float: left;
            }

            span {
              font-weight: 500;
              font-size: 16px;
              line-height: 22px;
              color: #0D0E12;
              float: left;
              margin-left: 8px;
            }
          }

          .deal_data {
            width: 100%;
            height: 100%;
          }
        }
      }

      .table {
        width: 100%;
        background: #fff;
        margin-bottom: 10px;
        border-radius: 8px;

        .dot_box {
          overflow: hidden;
          padding-top: 10px;
          margin-left: 12px;

          .dot {
            width: 4px;
            height: 10px;
            margin-top: 6px;
            background: #2B54FC;
            border-radius: 3px;
            float: left;
          }

          span {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #0D0E12;
            float: left;
            margin-left: 8px;
          }
        }

        .deal_data {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
<style lang="less">
  .el-date-editor--year {

    width: 100px;
    height: 36px;
    position: relative;

    .el-input__inner {
      height: 36px !important;
      line-height: 36px;
    }
  }
</style>
